import { connect } from "react-redux";
import styled from "styled-components";
import { getUrl, requests } from "../../globals/requests";
import { Button } from "../../components";
import download from "downloadjs";

const Container = styled.div`
  background-color: var(--white);
  padding: var(--verticalMargin);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: var(--verticalMargin);
  position: relative;
  min-width: 100%;
`;

const InsideContainer = styled.div`
  background-color: var(--shadow);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: var(--verticalMargin);
`;

const InsideTitle = styled.div`
  font-size: var(--fontSizeLarge);
  font-weight: var(--fontWeightBold);
  margin-bottom: var(--verticalMargin);
`;

function getFormatedDate() {
  const date = `${new Date().getFullYear()}-${
    new Date().getMonth() + 1
  }-${new Date().getDate()}_${new Date().getHours()}-${new Date().getMinutes()}`;
  return date;
}

function CSV() {
  async function getUsers() {
    const url = `${getUrl("webCsv")}/getAllUsersCsv`;
    const response = await requests.getBlobWithAuth(url);
    download(response.data, "users." + getFormatedDate() + ".csv", "text/csv");
  }
  async function getTrips() {
    const url = `${getUrl("webCsv")}/getAllTripsCsv`;
    const response = await requests.getBlobWithAuth(url);
    download(response.data, "trips." + getFormatedDate() + ".csv", "text/csv");
  }
  async function getOrganisations() {
    const url = `${getUrl("webCsv")}/getAllOrganisationsCsv`;
    const response = await requests.getBlobWithAuth(url);
    download(
      response.data,
      "organisations." + getFormatedDate() + ".csv",
      "text/csv"
    );
  }
  return (
    <Container>
      <InsideTitle>Whole database</InsideTitle>
      <InsideContainer>
        <Button title="Get users" onClick={getUsers} type="primary"></Button>
        <Button title="Get trips" onClick={getTrips} type="primary"></Button>
        <Button
          title="Get organisations"
          onClick={getOrganisations}
          type="primary"></Button>
      </InsideContainer>
    </Container>
  );
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(CSV);
